<!-- Floating In-App Push Notification Toasts -->
<div class="chat-toast-container" *ngIf="activeToasts.length > 0">
  <div
    *ngFor="let toast of activeToasts"
    class="chat-toast-card"
    (click)="onToastClick(toast)"
  >
    <div class="chat-toast-avatar">
      <img
        *ngIf="toast.senderAvatar; else initialsTpl"
        [src]="toast.senderAvatar"
        [alt]="toast.senderName"
      />
      <ng-template #initialsTpl>
        <span class="chat-toast-initials">{{ toast.senderInitials }}</span>
      </ng-template>
    </div>
    <div class="chat-toast-content">
      <div class="chat-toast-header">
        <span class="chat-toast-name">{{ toast.senderName }}</span>
        <span class="chat-toast-badge">New Message</span>
      </div>
      <div class="chat-toast-body">
        {{ toast.messageText }}
      </div>
    </div>
    <div class="chat-toast-actions">
      <button
        type="button"
        class="chat-toast-close"
        (click)="dismissToast(toast.id, $event)"
        title="Dismiss"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</div>


<div class="footer-chat-dock" *ngIf="showDock" #footerChatDock>
  <div class="footer-shell">
    <div class="dock-row">
    <!-- Dock unit: panel + footer tabs as one connected block -->
    <div class="dock-unit" [class.is-open]="panelOpen">
      <div class="dock-panel" *ngIf="panelOpen">
        <div class="dock-panel-header">
          <div class="dock-user">
            <span class="dock-user-avatar">
              <img
                *ngIf="userAvatarUrl"
                [src]="userAvatarUrl"
                [alt]="userName"
                (error)="onUserAvatarError()"
              />
              <span *ngIf="!userAvatarUrl" aria-hidden="true">{{ userInitials }}</span>
            </span>
            <div class="dock-user-info">
              <span class="dock-user-name">{{ userName }}</span>
              <span
                class="dock-user-status"
                [class.dock-user-status--offline]="connectionStatus === 'offline'"
                [class.dock-user-status--reconnecting]="
                  connectionStatus === 'reconnecting' ||
                  connectionStatus === 'connecting' ||
                  connectionStatus === 'online'
                "
              >
                {{ connectionStatusLabel }}
              </span>
            </div>
          </div>
          <div class="dock-panel-actions">
            <button type="button" class="dock-icon-btn" (click)="minimizePanel()" title="Minimize">
              <i class="pi pi-minus"></i>
            </button>
            <!-- <button type="button" class="dock-icon-btn" (click)="closeAll()" title="Close">
              <i class="pi pi-times"></i>
            </button> -->
          </div>
        </div>

        <div class="dock-search">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="dock-search-input"
            placeholder="Search Contacts, Chats &amp; Channels"
            [(ngModel)]="searchQuery"
          />
        </div>

        <div class="dock-panel-content">
          <app-channel-list
            [activeChannelId]="activeChannelId"
            [openChannelIds]="openChannelIds"
            [viewTab]="activeTab"
            [channelsSubTabPreference]="channelsSubTabPreference"
            variant="dock"
            [showHeader]="false"
            [externalSearch]="searchQuery"
            (channelSelected)="onChannelSelected($event)"
          ></app-channel-list>
        </div>
      </div>

      <!-- Footer tabs — always visible, connected to panel above -->
      <nav class="footer-tab-bar">
        <div class="footer-tab-items">
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'chats'"
            (click)="openTab('chats')">
            <i class="pi pi-comment"></i>
            <span *ngIf="directUnread > 0" class="footer-tab-badge">
              {{ directUnread > 99 ? '99+' : directUnread }}
            </span>
          </button>
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'channels'"
            (click)="openTab('channels')">
            <i class="pi pi-users"></i>
            <span *ngIf="channelUnread > 0" class="footer-tab-badge">
              {{ channelUnread > 99 ? '99+' : channelUnread }}
            </span>
          </button>
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'contacts'"
            (click)="openTab('contacts')">
            <i class="pi pi-user"></i>
          </button>
        </div>
      </nav>
    </div>

    <!-- Conversation windows — up to 2 side by side -->
    <div class="dock-conversations" *ngIf="openWindows.length > 0">
      <div
        class="dock-conversation"
        *ngFor="let win of openWindows; trackBy: trackWindow"
        [class.expanded]="win.size === 'expanded' && !win.minimized"
        [class.minimized]="win.minimized"
        [class.focused]="focusedChannelId === win.channel.id"
        (mousedown)="focusWindow(win.channel.id)"
      >
        <div
          class="dock-conversation-header"
          [class.clickable]="win.minimized"
          (click)="onMinimizedHeaderClick(win.channel.id)"
        >
          <div class="dock-conversation-info">
            <span class="dock-conversation-avatar">
              <img
                *ngIf="conversationAvatarUrl(win)"
                [src]="conversationAvatarUrl(win)"
                [alt]="getChannelTitle(win)"
                (error)="onAvatarError(win)"
              />
              <span *ngIf="!conversationAvatarUrl(win)" aria-hidden="true">{{
                conversationAvatarInitials(win)
              }}</span>
            </span>
            <div class="dock-conversation-text">
              <span class="dock-conversation-title">{{ getChannelTitle(win) }}</span>
              <button
                *ngIf="showParticipantLink(win)"
                type="button"
                class="dock-conversation-link"
                (click)="openParticipantsDialog(win.channel.id); $event.stopPropagation()"
              >
                {{ participantCountLabel(win) }}
              </button>
            </div>
          </div>
          <div class="dock-conversation-actions">
            <ng-container *ngIf="!win.minimized">
              <button
                type="button"
                class="dock-icon-btn"
                (click)="minimizeConversation(win.channel.id); $event.stopPropagation()"
                title="Minimize"
              >
                <i class="pi pi-minus"></i>
              </button>
              <button
                type="button"
                class="dock-icon-btn"
                (click)="toggleExpand(win.channel.id); $event.stopPropagation()"
                [title]="win.size === 'expanded' ? 'Restore' : 'Expand'"
              >
                <i
                  class="pi"
                  [ngClass]="win.size === 'expanded' ? 'pi-window-minimize' : 'pi-window-maximize'"
                ></i>
              </button>
            </ng-container>
            <button
              type="button"
              class="dock-icon-btn"
              (click)="closeChatWindow(win.channel.id); $event.stopPropagation()"
              title="Close"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        </div>
        <div class="dock-conversation-body">
          <app-chat-window
            [channel]="win.channel"
            [showHeader]="false"
            [showInlineGroupMembers]="true"
            [renderInlineParticipantLink]="false"
            [isMinimized]="win.minimized"
          ></app-chat-window>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
